// extracted by mini-css-extract-plugin
module.exports = {"container":"Spotlight_container__ItlFI","title":"Spotlight_title__QXfLV","entries":"Spotlight_entries__fL7N7","button":"Spotlight_button__87KZr","logo":"Spotlight_logo__zkPbx"};